import React, { useState } from "react";
import { toast } from "react-toastify";
import { getAttribution } from "../../utils/attribution";

const CtaForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    email: "",
    company: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validate = () => {
    let formIsValid = true;
    let errors = {};
    if (!formData.name) {
      formIsValid = false;
      errors.name = "Name is requierd";
    }

    if (!formData.email) {
      formIsValid = false;
      errors.email = "Email is requierd";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      formIsValid = false;
      errors.email = "Email is invalid";
    }

    if (!formData.company) {
      formIsValid = false;
      errors.company = "Company is required";
    }

    setErrors(errors);
    return formIsValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isValid = validate();
    if (!isValid) return;

    try {
      const attribution = getAttribution();

      const response = await fetch("/api/sendMail", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...formData,
          formType: "cta",
          attribution,
        }),
      });

      const result = await response.json();

      if (result.success) {
        if (Array.isArray(window.dataLayer)) {
          const a = attribution || {};
          window.dataLayer.push({
            event: "cta_form_submission", // renier must give correct event name
            utm_source: a.utm_source || "",
            utm_medium: a.utm_medium || "",
            utm_campaign: a.utm_campaign || "",
          });
        }

        toast.success(result.message || "Your enquiry was sent successfully!", {
          position: "bottom-right",
          autoClose: 5000,
        });

        setFormData({
          name: "",
          email: "",
          company: "",
        });

        setErrors({
          name: "",
          email: "",
          company: "",
        });
      } else {
        toast.error(
          result.message || "There was a problem sending your enquiry.",
          {
            position: "bottom-right",
            autoClose: 5000,
          }
        );
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Something went wrong. Please try again later.", {
        position: "bottom-right",
        autoClose: 5000,
      });
    }
  };

  return (
    <form data-form="cta" className="cta_form" onSubmit={handleSubmit}>
      <div className="input_filled">
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Your Name*"
        />
        {errors.name && <span className="error">{errors.name}</span>}
      </div>
      <div className="input_filled">
        <input
          type="text"
          name="email"
          placeholder="Your Email*"
          value={formData.email}
          onChange={handleChange}
        />
        {errors.email && <span className="error">{errors.email}</span>}
      </div>
      <div className="input_filled">
        <input
          type="text"
          name="company"
          placeholder="Your Company*"
          value={formData.company}
          onChange={handleChange}
        />
        {errors.company && <span className="error">{errors.company}</span>}
      </div>
      <div className="input_filled">
        <button type="submit">Free Consultancy</button>
      </div>
    </form>
  );
};

export default CtaForm;
